var _jsxFileName = "/repo/packages/ippm/src/components/experiment/IG2072EduVisibility/EduVisibilityBanner.js",
  _this = this;
import React from 'react';
var EduVisibilityBanner = function EduVisibilityBanner() {
  return /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4,
      columnNumber: 10
    }
  }, "edu visibility banner");
};
export default EduVisibilityBanner;